import { render } from "./ownerDetails.vue?vue&type=template&id=5c7d01ea&scoped=true&lang=true"
import script from "./ownerDetails.vue?vue&type=script&lang=js"
export * from "./ownerDetails.vue?vue&type=script&lang=js"

import "./ownerDetails.vue?vue&type=style&index=0&id=5c7d01ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c7d01ea"]])

export default __exports__